import * as Request from "superagent";
import CustomEvent from "custom-event";
import { ApiBasePath } from "../utils/ApiBasePath";
import each from "lodash/each";
import { ModalType } from "./Modals/Modal";
import ImgLazyLoad from "./ImgLazyLoad";
import ReactDOM from "react-dom";
import React from "react";

interface SocialCardInterface {
  Image: string;
  Title?: string;
  Description?: string;
  Url?: string;
}

enum SocialCardsTypes {
  USER = "USER",
  PARTNER = "PARTNER"
}

class SocialCard {
  private posts: SocialCardInterface[] = [];
  private group: HTMLDivElement = null;
  private type: SocialCardsTypes = SocialCardsTypes.USER;
  private currentPostIndex: number = 0;
  private postsPerPage: number = 8;
  private postsFirstPage: number = 4;
  private butt;
  private button: any = null;

  constructor(group: HTMLDivElement) {
    this.group = group;
    this.postsPerPage = parseInt(group.getAttribute("data-postsPerPage"), 10) || 8;
    this.postsFirstPage = parseInt(group.getAttribute("data-postsFirstPage"), 10) || this.postsPerPage;
    this.button = group.querySelector(".cards__moreWrap .btn");

    if (group.getAttribute("data-type").toUpperCase() === "PARTNERS") {
      this.type = SocialCardsTypes.PARTNER;
    }

    this.loadCards()
      .then((response: any) => {
        const newData = response.body.map((data)=> ({
          Type: data.type,
          Image: data.image,
          Title:  data.title,
          Description: data.Description,
          Url: data.url
        }));
    
        this.posts = this.shuffle(response.body.response || newData);
        this.renderCards(this.postsFirstPage);
      })
      .catch(() => console.log("fail"));

    if (this.button) {
      this.button.addEventListener("click", () => {
        this.renderCards(this.postsPerPage);
      });
    }
  }

  private shuffle(arr: any[]): any[] {
    return arr
      .map(a => [Math.random(), a])
      .sort((a, b) => a[0] - b[0])
      .map(a => a[1]);
  }

  private loadCards(): Promise<any> {
    let url = `/api/socialcard?top=30`;

    switch (this.type) {
      case SocialCardsTypes.USER:
        url += "&type=user";
        break;

      case SocialCardsTypes.PARTNER:
        url += "&type=partner";
        break;
    }
    return new Promise((resolve, reject) => Request.get(url).then(resolve, reject));
  }

  private buildCard(cardData: SocialCardInterface): HTMLDivElement {
    const card = document.createElement("div");
    const inner = document.createElement("div");
    const imageContainer = document.createElement("div"); // container for React ImgLazyLoad
  
    card.className = "cards__item cards__item--loading";
    inner.className = "cards__inner";
  
    imageContainer.className = "cards__image"; // optional class for styling
    inner.appendChild(imageContainer);
  
    // Render ImgLazyLoad React component inside imageContainer
    ReactDOM.render(
      <ImgLazyLoad
        src={cardData.Image}
        alt={cardData.Title || ""}
        onLoad={() => {
          card.classList.remove("cards__item--loading");
        }}
      />,
      imageContainer
    );
  
    if (this.type === SocialCardsTypes.PARTNER) {
      card.classList.add("cards__item--socialPartner");
      const copyWrap = document.createElement("div");
      const title = document.createElement("h5");
      const copy = document.createElement("p");
  
      copyWrap.className = "cards__copy";
      title.textContent = cardData.Title;
      title.className = "h5";
      copy.textContent = cardData.Description;
  
      copyWrap.appendChild(title);
      copyWrap.appendChild(copy);
      inner.appendChild(copyWrap);
  
      card.addEventListener("click", () => this.showModal(cardData));
    } else {
      card.classList.add("cards__item--socialUser");
    }
  
    card.appendChild(inner);
  
    return card;
  }

  private renderCards(amount: number = this.postsPerPage): void {
    const newPostIndex = this.currentPostIndex + amount;
    const cards: SocialCardInterface[] = this.posts.slice(this.currentPostIndex, newPostIndex);

    const docFragment = document.createDocumentFragment();

    cards.forEach((cardData: SocialCardInterface) => {
      docFragment.appendChild(this.buildCard(cardData));
    });
    this.group.insertBefore(docFragment, this.button && this.button.parentNode);

    if (this.button) {
      if (this.posts.length - newPostIndex < 1) {
        this.button.parentNode.style.display = "none";
      } else {
        this.button.parentNode.style.visibility = "visible";
      }
    }

    this.currentPostIndex = newPostIndex;
  }

  private showModal(card: SocialCardInterface): void {
    const evt = new CustomEvent("showModal", {
      detail: {
        type: ModalType.IFRAME,
        iFrameUrl: card.Url
      }
    });
    window.dispatchEvent(evt);
  }
}

export const SocialCards = (): void =>
  each(document.querySelectorAll(".socialCards"), (group: HTMLDivElement) => new SocialCard(group));
